// [ai] A trusted module: the server compiles vault/atlas/views/<slug>/<src> with esbuild (POST …/compile → a URL under
// /api/views/<slug>/module/), the app imports it (react + @atlas/sdk resolve to the app's own, see sdk/vendor.ts) and renders
// its default export under the frame's host. Local only (DOSSIER_TRUSTED_WIDGETS=1): the flag off is an error card, not a load.
import { useEffect, useState, type ComponentType } from "react";
import { HttpError } from "../api/http";
import { compileModule } from "../api/widgets";
import { AtlasContext } from "../sdk/react";
import type { AtlasHost } from "../sdk/types";
import { Boundary, Rendered } from "./cards";
import { useWidgetsCtl } from "./widgets";

export const TRUSTED_OFF = "trusted widgets are off here";
type Props = { slug: string; src: string; host: AtlasHost; onReady: () => void; onError: (msg: string) => void };
export function ModuleWidget({ slug, src, host, onReady, onError }: Props) {
  const w = useWidgetsCtl(); const [Comp, setComp] = useState<ComponentType | null>(null);
  useEffect(() => {
    let live = true;
    void (async () => {
      try {
        const { url } = await compileModule(slug, src);
        const mod = (await w.importModule(url)) as { default?: unknown } | null;
        const C = mod?.default;
        if (typeof C !== "function") throw new Error(`${src} has no default export component`);
        if (live) setComp(() => C as ComponentType);
      } catch (e) { if (live) onError(e instanceof HttpError && e.status === 403 ? TRUSTED_OFF : e instanceof Error ? e.message : String(e)); }
    })();
    return () => { live = false; };
  }, [w, slug, src, onError]);
  if (!Comp) return <div className="at-widget-wait">Loading…</div>;
  return <AtlasContext.Provider value={host}><Boundary onError={onError}><Comp /><Rendered onReady={onReady} /></Boundary></AtlasContext.Provider>;
}
